import { defineComponent, ref, onBeforeUnmount, onMounted, computed } from "vue";
import { SvgIcon } from "@/components/index.ts";
import wifiSvg from "@/assets/images/svg/wifi.svg";
import noWifiSvg from "@/assets/images/svg/no-wifi.svg";
import { LogService } from "@/services/logging";
export default defineComponent({
  name: "NavbarDetectInternet",
  components: {
    SvgIcon: SvgIcon
  },
  setup: function setup() {
    var isOnline = ref(window.navigator.onLine);
    var iconStyle = "filter: contrast(170%) invert(100%);";
    var iconContent = computed(function () {
      return isOnline.value ? wifiSvg : noWifiSvg;
    });
    var iconAlt = computed(function () {
      return isOnline.value ? "wifi" : "no wifi";
    });

    var updateOnlineStatus = function updateOnlineStatus(e) {
      var type = e.type;
      isOnline.value = type === "online";

      if (!isOnline.value) {
        // log will be synced once internet connection is restored
        LogService.info("No internet connection found. App is running in offline mode.");
      }
    };

    onMounted(function () {
      window.addEventListener("online", updateOnlineStatus);
      window.addEventListener("offline", updateOnlineStatus);
    });
    onBeforeUnmount(function () {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    });
    return {
      isOnline: isOnline,
      iconContent: iconContent,
      iconAlt: iconAlt,
      iconStyle: iconStyle
    };
  }
});